import styled from 'styled-components';

import { Flex, fontSizeAdaptative, gridSizes, media } from 'utils/style';

import DeniedMethodAdvice from 'components/orders/DeniedMethodAdvice/container';

export default styled(DeniedMethodAdvice)`
  ${Flex.row};
  align-items: center;
  width: 100%;
  background: var(--accent700);
  color: var(--white);
  padding: ${gridSizes('M')} ${gridSizes('L')};

  .nowrap {
    white-space: nowrap;
  }

  ${fontSizeAdaptative};
  ${media.lessThan('medium')`
    padding: ${gridSizes('M')};
  `};
`;
